import styled from 'styled-components';

export const Header = styled.div`
  position: absolute;
  top: 1.6rem;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 6;
  pointer-events: none;
`;

export const FilterTabs = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.6rem;
  pointer-events: auto;
`;

export const FilterTab = styled.button`
  position: relative;
  border: none;
  padding: 0;
  background: transparent;
  color: ${({ $active }) => ($active ? '#fff' : 'rgba(255, 255, 255, 0.72)')};
  font-size: 1.4rem;
  font-weight: ${({ $active }) => ($active ? 600 : 500)};
  cursor: pointer;

  &::after {
    content: '';
    position: absolute;
    left: 50%;
    bottom: -0.7rem;
    width: ${({ $active }) => ($active ? '3.2rem' : '0')};
    height: 0.2rem;
    border-radius: 999px;
    background: #fff;
    transform: translateX(-50%);
    transition: width 180ms ease;
  }
`;
